import axios from 'axios'
import { MessageBox, Loading } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

let loading // 定义loading变量
export const homePageUrl = process.env.VUE_APP_HOME_PAGE // 首页地址
function startLoading() {
  loading = Loading.service({
    lock: true,
    pinner: 'el-icon-loading',
    fullscreen: true,
    background: 'rgba(0, 0, 0, 0.5)'
  })
}

function endLoading() {
  loading.close()
}
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 600000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    // 添加时间戳 防止get请求缓存
    if (['get', 'delete', 'head', 'options'].some(m => m === config.method)) {
      config.url = config.url.indexOf('?') === -1 ? (config.url + '?_=' + (new Date()).getTime()) : (config.url + '&_=' + (new Date()).getTime())
    }

    config.headers['Token'] = 'Bearer ' + (window.localStorage.getItem('token') || '')
    startLoading()
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (res.unAuthorizedRequest) {
      window.location.href = homePageUrl
      return
    }
    // if the custom code is not 20000, it is judged as an error.
    if (!res.success && res.message) {
      MessageBox.confirm(res.message || 'Error', '提示', {
        type: 'error',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showCancelButton: false
      }).then(() => {
        endLoading()
        return Promise.reject(new Error(res.message || 'Error'))
      })
    } else {
      endLoading()
      if (response.request.responseType === 'blob') {
        if (response.status === 200) {
          return response
        } else {
          return Promise.reject('Error')
        }
      } else {
        if(res.errorcode === 120){
          window.location.href = '/#/login'
          return
        }
        return (res.result !== null && res.result !== undefined) ? res.result : res
        // return res
      }
    }
  },
  error => {
    console.log(error.request.readyState)
    if (error.request.readyState === 4 && error.request.status === 0) {
      // 请求超时
      MessageBox.confirm('请求超时', '提示', {
        type: 'error',
        showCancelButton: false,
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        endLoading()
      })
      return Promise.reject(error)
    }
    if (!!error.response && !!error.response.data.error && !!error.response.data.error.message) {
      MessageBox.confirm(error.response.data.error.message, '提示', {
        type: 'error',
        showCancelButton: false,
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        endLoading()
      })
    } else if (!error.response) {
      MessageBox.confirm('系统错误', '提示', {
        type: 'error',
        showCancelButton: false,
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        endLoading()
      })
    }
    return Promise.reject(error)
  }
)

export default service
